import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { listInvoiceMasterRange, listPurchaseMasterRangeCustom } from "../../graphql";


export const gstReportApi = createApi({
    reducerPath: "gstReportApi",
    baseQuery,
    endpoints: (builder) => ({
        fetchGstReportSales: builder.query({
            query: (variables) => ({
                body: listInvoiceMasterRange,
                variables
            }),
            providesTags: (result, error, { startdate, enddate }) => [{ startdate, enddate }, 'GSTRSales'],
            keepUnusedDataFor: 300,
        }),
        fetchGstReportPurchase: builder.query({
            query: (variables) => ({
                body: listPurchaseMasterRangeCustom,
                variables
            }),
            providesTags: (result, error, { startdate, enddate }) => [{ startdate, enddate }, 'GSTRPurchase'],
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
        }),
    })
})

export const { useFetchGstReportSalesQuery, useFetchGstReportPurchaseQuery } = gstReportApi;